import React, { useContext } from "react";
import { useTerms } from "@queries/useTerms";
import { ApplicationContext } from "@context/ApplicationContext";
import Loader from "@components/Ui/Loader";
import "./style.scss";

const Terms = () => {
    const { subscriberGroupId } = useContext(ApplicationContext);
    const { terms, isLoading } = useTerms(subscriberGroupId);

    if (isLoading) {
        return <Loader isLoading={isLoading} />;
    }

    return (
        <div className="terms__wrapper admin-content">
            {terms ? (
                // eslint-disable-next-line react/no-danger
                <div className="terms__content" dangerouslySetInnerHTML={{ __html: terms }} />
            ) : (
                <p className="paragraph">Terms and conditions content to follow</p>
            )}
        </div>
    );
};

export default Terms;
